const initialState = "";

const tempUser = (state = initialState, action) => {
    switch (action.type) {
        case 'HANDLE_FULL_NAME':
            state = action.payload.fullName
            return state;

        default:
            return state;
    }
};

export default tempUser;